import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { CLASS_TEACHER_SUBSCRIBERS } from "../graphql/queries";

export const usePeople = () => {
  const [classTeacherStudent, setClassTeacherStudent] = useState({
    teachers: [],
    subscribers: [],
    isWorking: false,
  });
  const { id } = useParams();

  const [getClassInfo] = useLazyQuery(CLASS_TEACHER_SUBSCRIBERS, {
    onCompleted: (data) => {
      setClassTeacherStudent({
        teachers: data.organizationClass.creator,
        subscribers: data.organizationClass.subscribers,
      });
    },
    onError: (e) => {
      console.log(e);
    },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (!!id) {
      getClassInfo({
        variables: {
          where: {
            id,
          },
        },
      });
    }
  }, [id, getClassInfo]);

  const addNewSubscriber = (subscribers) => {
    setClassTeacherStudent({
      ...classTeacherStudent,
      subscribers: subscribers,
    });
  };

  const removeSubscriber = (id) => {
    setClassTeacherStudent({
      ...classTeacherStudent,
      subscribers: classTeacherStudent.subscribers.filter((s) => s.id !== id),
    });
  };

  const setIsWorking = (value) => {
    setClassTeacherStudent({
      ...classTeacherStudent,
      isWorking: value,
    });
  };

  return {
    classTeacherStudent,
    addNewSubscriber,
    removeSubscriber,
    setIsWorking,
  };
};
